import React, {useState} from "react";
import {
  CloseOutlined,
  EditOutlined,
  MinusOutlined,
  PlusOutlined,
  SaveOutlined
} from "@ant-design/icons";
import { Button, Input, InputNumber, Popconfirm, Table } from "antd";
import { EditableFormItem } from "./EditableFormItem";


const { Column } = Table;


export const EditableUsersTable = props => {
  const { users, form, add, remove } = props;
  const [editingIndex, setEditingIndex] = useState(undefined);
  const [isNewUser, setNewUser] = useState(false);

  const addUser = () => {
    add();
    setEditingIndex(users.length);
    setNewUser(true);
  };

  const onSave = () => {
    form
      .validateFields()
      .then(() => {
        setNewUser(false);
        setEditingIndex(undefined);
      })
      .catch(error => {
        // console.log(error.errorFields);
      });
  };

  const onCancel = (index) => {
    if (isNewUser) {
      remove(index);
    } else {
      form.resetFields([["users", index, "age"], ["users", index, "name"]]);
    }

    setNewUser(false);
    setEditingIndex(undefined);
  };

  return (
    <Table
      dataSource={users}
      pagination={false}
      footer={() => (
        <Button onClick={addUser}>
          <PlusOutlined /> Add User
        </Button>
      )}
    >
      <Column
        dataIndex={"age"}
        title={"Age"}
        width={'40%'}
        render={(value, row, index) => {
          return (
            <EditableFormItem
              name={[index, "age"]}
              editing={index === editingIndex}
              className={"ant-form-item-no-bottom-margin"}
            >
              <InputNumber placeholder="age" min={0} max={150} />
            </EditableFormItem>
          );
        }}
      />
      <Column
        dataIndex={"name"}
        title={"Name"}
        width={'40%'}
        render={(value, row, index) => {
          return (
            <EditableFormItem
              rules={[{ required: true, message: "Name is required" }]}
              name={[index, "name"]}
              editing={index === editingIndex}
              className={"ant-form-item-no-bottom-margin"}
            >
              <Input placeholder="name" />
            </EditableFormItem>
          );
        }}
      />
      <Column
        title={"Action"}
        render={(value, row, index) => {
          if (index === editingIndex) {
            return (
              <React.Fragment>
                <Button
                  icon={<SaveOutlined />}
                  shape={"circle"}
                  type={"primary"}
                  style={{ marginRight: 8 }}
                  onClick={onSave}
                />
                <Button
                  icon={<CloseOutlined />}
                  shape={"circle"}
                  onClick={() => onCancel(index)}
                />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment>
                <Button
                  icon={<EditOutlined />}
                  shape={"circle"}
				  type={"primary"}
                  style={{ marginRight: 8, }}
                  disabled={editingIndex !== undefined}
                  onClick={() => setEditingIndex(index)}
                />
                <Popconfirm
                  title="Are you sure？"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => remove(index)}
				  disabled={editingIndex !== undefined}
                >
                  <Button
                    icon={<MinusOutlined />}
                    shape={"circle"}
					danger
                    disabled={editingIndex !== undefined}
                  />
                </Popconfirm>
              </React.Fragment>
            );
          }
        }}
      />
    </Table>
  );
};
